import { atomWithKey as atom } from "./atomWithKey";

export const promoCodeErrorAtom = atom<string>({
    key: "promoCodeErrorAtom",
    default: "",
});
export const listOfAppliedPromoCodeAtom = atom<string[]>({
    key: "listOfAppliedPromoCodeAtom",
    default: [],
});
